// extracted by mini-css-extract-plugin
export default {"title":"VideoSeeMore_title__6HPys"};